// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PortletsMgrOutlinedSvg from "@fishx/icons-svg/es/asn/PortletsMgrOutlined";
import FishxIcon from '../components/FishxIcon';

var PortletsMgrOutlined = function PortletsMgrOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PortletsMgrOutlinedSvg
  }));
};

PortletsMgrOutlined.displayName = 'PortletsMgrOutlined';
export default React.forwardRef(PortletsMgrOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PortletsMgrOutlined.js
// module id = 3825
// module chunks = 0